import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  normalHeight: {
    padding: 'calc(50% - 1px) calc(50% - 65px)',
  },
  fullHeight: {
    padding: 'calc(50vh - 1px) calc(50% - 65px)',
  },
  overlay: {
    position: 'fixed',
    zIndex: 9999,
    background: 'rgba(179, 178, 178, 0.5)',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
  },
  loadingBar: {
    width: 130,
    height: 3,
    background: '#cfcfcf',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 15,
    '&::before': {
      flip: false,
      content: '""',
      display: 'block',
      width: 68,
      height: 3,
      background: 'black',
      position: 'absolute',
      left: -34,
      borderRadius: 15,
      animation: '$slideBar 1.5s infinite ease',
    },
  },
  '@keyframes slideBar': {
    '50%': {
      flip: false,
      left: 96,
    },
  },
}))
const BarSpinner = ({ fullPage, style, overlay }) => {
  const classes = useStyles()

  return (
    <div
      className={clsx({
        [classes.normalHeight]: !fullPage,
        [classes.fullHeight]: fullPage,
        [classes.overlay]: overlay,
      })}
      style={style}
    >
      <div className={classes.loadingBar}></div>
    </div>
  )
}
export default BarSpinner
